module.exports = __webpack_public_path__ + "media/newstyle/images/icon-profile-red-b484dba667f770eb41b3f7b4c5af8d21.svg";